<template>
  <div>
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="section-title mb-0">
        {{ $tc("add") }} {{ $tc("weekwiseContract", 2) }}
      </h6>
      <router-link class="btn btn-primary btn-sm" to="weekwise-contract">
        {{ $tc("weekwiseContract", 2) }} {{ $tc("list", 2) }}
      </router-link>
    </div>

    <div class="card p-3 shadow-sm">
      <!-- Contract Name + Status -->
      <div class="row mb-3">
        <div class="col-md-4 col-12">
          <label for="weekwise_name" class="form-label fw-bold small mb-1">
            {{ $t("weekwise") }} {{ $tc("contract", 2) }} {{ $tc("name", 2) }}
          </label>
          <input
            id="weekwise_name"
            v-model="contract_weekwise_name"
            v-b-tooltip.hover
            v-validate="'required'"
            :title="$t('contract_name_tooltip')"
            type="text"
            class="form-control slick-column"
            placeholder="Enter contract name"
          />
          <small class="text-danger">
            <span v-if="submitted && errors.has('weekwise_name')">
              {{ errors.first("weekwise_name") }}
            </span>
          </small>
        </div>
        <div class="col-lg-8 d-flex align-items-center justify-content-end">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox"
              v-model="contracts_by_weekwise_is_active"
            />
          </div>
          <!-- <b-form-checkbox
            v-model="contracts_by_weekwise_is_active"
            name="check-button"
            switch
          >
            {{ $t("active") }}
          </b-form-checkbox> -->
        </div>
      </div>

      <!-- Table of Contracts -->
      <table
        class="table table-bordered table-sm align-middle text-center no-padding-table"
      >
        <thead class="table-light">
          <tr>
            <th style="width: 30%">{{ $t("week") }}</th>
            <th style="width: 30%">{{ $t("contract") }}</th>
            <th style="width: 13%">Min Threshold</th>
            <th style="width: 13%">Complimentary %</th>
            <th style="width: 30%">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(WeekwiseContract, WeekwiseContractKey) in WeekwiseContracts"
            :key="WeekwiseContractKey"
          >
            <!-- Week Select -->
            <td class="text-right p-0 slick-table-item">
              <multiselect
                :value="WeekwiseContract.contract_week"
                :options="
                  weekArray.filter(
                    (w) => w.value == WeekwiseContractKey || w.value == -1
                  )
                "
                :placeholder="selectedWeek"
                label="name"
                track-by="value"
                @select="onSelectWeek($event, WeekwiseContractKey)"
                class=""
              />
              <small
                class="text-danger"
                v-if="submitted && !WeekwiseContract.contract_week"
              >
                <span v-if="submitted && !WeekwiseContract.contract_week">
                  {{ selectedWeek }}
                </span>
              </small>
            </td>

            <!-- Contract Select -->
            <td class="text-right p-0 slick-table-item">
              <multiselect
                :value="WeekwiseContract.contract_id"
                :options="ms_contracts"
                :placeholder="selectedContract"
                label="contract_name"
                track-by="contract_id"
                @select="onSelectContract($event, WeekwiseContractKey)"
                class=""
              />
              <small
                class="text-danger"
                v-if="submitted && !WeekwiseContract.contract_id"
              >
                <span v-if="submitted && !WeekwiseContract.contract_id">
                  {{ selectedContract }}
                </span>
              </small>
            </td>

            <!-- Min Threshold -->
            <td class="text-right p-0 slick-column">
              <input
                v-model="WeekwiseContract.minimum_threshold"
                type="number"
                class="text-center"
                placeholder="0"
              />
            </td>

            <!-- Complimentary % -->
            <td class="text-right p-0 slick-column">
              <input
                v-model="WeekwiseContract.allowed_comp_percentage"
                type="number"
                class="text-center"
                placeholder="0"
              />
            </td>

            <!-- Action Buttons -->
            <td>
              <button
                v-if="WeekwiseContractKey === 0"
                class="btn-icon"
                @click.stop.prevent="addWeekWiseContract"
              >
                +
              </button>
              <button
                v-if="
                  WeekwiseContractKey !== 0 &&
                    WeekwiseContractKey === WeekwiseContracts.length - 1
                "
                class="btn-icon"
                @click.stop.prevent="
                  removeWeekWiseContract(WeekwiseContractKey)
                "
              >
                –
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Save Button -->
      <div class="text-center mt-3">
        <button
          :disabled="btenable"
          class="btn btn-primary btn-sm px-4"
          @click.prevent.stop="onFinalSubmit"
        >
          Save Contract
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import DistributorService from "@/services/DistributorService";

  export default {
    data() {
      return {
        submitted: false,
        btenable: false,
        contract_weekwise_name: "",
        contracts_by_weekwise_is_active: true,
        ms_contracts: [],
        weekArray: [
          { name: "Week 1", value: 0 },
          { name: "Week 2", value: 1 },
          { name: "Week 3", value: 2 },
          { name: "Week 4", value: 3 },
          { name: "Week 5", value: 4 },
          { name: "Week 6", value: 5 },
          { name: "Thereafter", value: -1 },
        ],
        selectedContract: "Contract Type.",
        selectedWeek: "Week.",
        WeekwiseContracts: [
          {
            contract_week: "",
            contract_id: "",
            minimum_threshold: "",
            allowed_comp_percentage: "",
          },
        ],
      };
    },
    mounted() {
      this.getActiveContracts();
    },
    methods: {
      getActiveContracts() {
        let payload = { tableName: "ms_contracts", contract_is_active: "Y" };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ms_contracts = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      addWeekWiseContract() {
        console.log("Before adding:", this.WeekwiseContracts);
        if (
          this.WeekwiseContracts.findIndex((w) => w.contract_week === -1) !== -1
        ) {
          this.$toasted.show(
            "You have already added 'Thereafter'. Cannot add any more weeks."
          );
          return;
        } else {
          this.WeekwiseContracts.push({
            contract_week: "",
            contract_id: "",
            minimum_threshold: "",
            allowed_comp_percentage: "",
          });
        }
        console.log("After adding:", this.WeekwiseContracts);
      },
      removeWeekWiseContract(index) {
        console.log("Removing contract at index:", index);
        this.WeekwiseContracts.splice(index, 1);
      },
      onSelectWeek(event, index) {
        console.log("week value=>", event);
        console.log(`Selected Week ${event.name} at index ${index}`);
        this.WeekwiseContracts[index].contract_week = event;

        if (event.value === -1 && this.WeekwiseContracts.length - 1 !== index) {
          this.WeekwiseContracts = this.WeekwiseContracts.slice(0, index + 1);
        }
      },
      onSelectContract(event, index) {
        console.log("contact event=>", event);
        console.log(
          `Selected Contract ${event.contract_name} at index ${index}`
        );
        this.WeekwiseContracts[index].contract_id = event;
      },
      ContractDetailsValidation() {
        let count = 0;
        this.WeekwiseContracts.map((x) => {
          if (!x.contract_week || !x.contract_id) count++;
        });

        const thereAfterIndex = this.WeekwiseContracts.findIndex(
          (w) => w.contract_week.value === -1
        );
        if (thereAfterIndex === -1) {
          this.$toasted.show("Please add a 'ThereAfter' contract.");
        }

        return count > 0 || thereAfterIndex === -1;
      },
      onFinalSubmit() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (this.ContractDetailsValidation()) {
            return;
          }
          if (valid) {
            this.btenable = true;
            let updateArray = this.WeekwiseContracts.map((row) => {
              row;
              return {
                contract_id: row.contract_id,
                contract_week: row.contract_week,
                minimum_threshold: row.minimum_threshold,
                allowed_comp_percentage: row.allowed_comp_percentage,
              };
            });
            console.log("updateArray=>", updateArray);
            let payload = {
              contract_weekwise_name: this.contract_weekwise_name,
              contracts_by_weekwise_is_active: this
                .contracts_by_weekwise_is_active
                ? "Y"
                : "N",
              WeekwiseContracts: updateArray,
            };
            DistributorService.AddMasterContractByWeekWise(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  this.$validator.reset();
                  this.$router.push({ path: "weekwise-contract" });
                  this.$toasted.show(data.message);
                } else {
                  this.$toasted.show(data.message || data.error.sqlMessage);
                }
              })
              .catch(this._CatchError);
          }
        });
      },
    },
  };
</script>

<style>
  .back {
    background-color: #fff;
  }

  .slick-table-item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .slick-table-item .multiselect__placeholder {
    color: #00000085 !important;
    font-weight: 400 !important;
    font-style: italic;
  }

  .slick-column .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .slick-column input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
  }

  .slick-column input::placeholder,
  .manual_bill_wrapper .multiselect__placeholder {
    font-size: 12px;
    font-style: italic;
  }
  /* Remove padding/margin from table cells */
  .no-padding-table th,
  .no-padding-table td {
    /* padding: 4px !important; */
    margin: 0 !important;
    vertical-align: middle !important;
  }

  .no-padding-table td {
    border: 1px solid #01070e;
  }

  .no-padding-table {
    zoom: 0.88;
  }

  /* Icon-only buttons (rounded border, no background) */
  .btn-icon {
    width: 28px;
    height: 28px;
    /* border: 1px solid #01070e; */
    border-radius: 50%;
    background: none;
    font-size: 16px;
    line-height: 1;
    padding: 0;
    text-align: center;
    cursor: pointer;
  }
  .btn-icon:hover {
    border-color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/WeekWiseContractComponents/addWeekwiseContract.vue